import axios from 'axios'
// import store from '@/store/store.js'
import VueCookie from 'vue-cookie'
import moment from 'moment'

export function refreshToken () {
  let data = JSON.stringify({
    refresh_token: VueCookie.get('excm_refreshToken')
  })
  axios.defaults.headers.common = {
    'Authorization': 'Bearer ' + VueCookie.get('excm_accessToken'),
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json'
  }
  axios
    .post('api/token/refresh', data,
      {
        headers: {
          'Content-Type': 'application/json'
        }
      })
    .then(response => {
      VueCookie.set('excm_accessToken', response.data.token, {
        expires: (response.data.exp - response.data.iat) + 's'
      })
      VueCookie.set('excm_refreshToken', response.data.refresh_token, {
        expires: (response.data.exp - response.data.iat) + 's'
      })
      VueCookie.set('expires_in', moment().add((response.data.exp - response.data.iat), 's').unix(), {
        expires: (response.data.exp - response.data.iat) + 's'
      })
      VueCookie.set('user_id', response.data.data.id_user, {
        expires: (response.data.exp - response.data.iat) + 's'
      })
      VueCookie.set('user_data_id', response.data.data.id_user_data, {
        expires: (response.data.exp - response.data.iat) + 's'
      })
      VueCookie.set('name', response.data.data.name, {
        expires: (response.data.exp - response.data.iat) + 's'
      })
      VueCookie.set('surname', response.data.data.surname, {
        expires: (response.data.exp - response.data.iat) + 's'
      })
      VueCookie.set('roles', JSON.stringify(response.data.data.roles), {
        expires: (response.data.exp - response.data.iat) + 's'
      })
      VueCookie.set('user_employer', response.data.data.user_employer, {
        expires: (response.data.exp - response.data.iat) + 's'
      })
      VueCookie.set('id_client_type', response.data.data.id_client_type, {
        expires: (response.data.exp - response.data.iat) + 's'
      })
      VueCookie.set('default_route', response.data.data.default_route, {
        expires: (response.data.exp - response.data.iat) + 's'
      })
      VueCookie.set('default_disable_roles_filtering', response.data.data.default_disable_roles_filtering, {
        expires: (response.data.exp - response.data.iat) + 's'
      })
      axios.defaults.headers.common = {
        Authorization: 'Bearer ' + VueCookie.get('accessToken')
      }
      // fetchUserData(user.data.expires_in)
      // console.log(user.data)
    })
    .catch(error => {
      console.log(error)
      // this.error = this.$t('views.login.index.wrongData')
    })
}

// export function fetchUserData (expires_in = 0 + 's') {
//   axios
//     .get(store.state.api.data_api + 'users/auth')
//     .then(response => {
//       VueCookie.set('user_id', response.data.id, {
//         expires: expires_in
//       })
//       VueCookie.set('userdata_id', response.data.id_userdata, {
//         expires: expires_in
//       })
//       VueCookie.set('name', response.data.name, {
//         expires: expires_in
//       })
//       VueCookie.set('surname', response.data.surname, {
//         expires: expires_in
//       })
//       VueCookie.set('roles', response.data.roles, {
//         expires: expires_in
//       })
//       store.state.user = response.data
//     })
//     .catch(error => {
//       this.$swal({
//         type: 'error',
//         title: 'Error :' + error,
//         showConfirmButton: true,
//         timer: 7000
//       })
//       this.$router.push({ path: '/500' })
//     })
// }
